export const GET_DATA_NPS_WATCHER = "app/WidgetResultNps/GET_DATA_NPS_WATCHER"
export const GET_DATA_NPS_SUCCESS = "app/WidgetResultNps/GET_DATA_NPS_SUCCESS"
export const GET_DATA_NPS_FAILED = "app/WidgetResultNps/GET_DATA_NPS_FAILED"
